RivalIQ.apps.Shell.module('views', function (views, App, Backbone, Marionette, $, _, moment) {

    'use strict';

    const periodType = RivalIQ.enums.timePeriod.periodType;

    const DatePicker = views.DatePicker = function (options) {
        const me = this;

        me.fieldPeriodType = periodType.MAIN_PERIOD;
        me.periodDateRanges = options.periodDateRanges;
        me.minDataDate = options.minDataDate;
        me.periods = options.periods;
        me.isDisabled = Boolean(options.isDisabled);
        me.timezone = options.timezone;

        me.options = _.extend({
            bound: false,
            numberOfMonths: 3,
            mainCalendar: 'right',
            disableDayFn: _.bind(me.disableDayFn, me),
            customDayClassFn: _.bind(me.customDayClassFn, me),
            onSelect: _.bind(me.onSelect, me),
            // initialize with the widest possible range
            // (we'll adjust the selectable dates based on the field as the input focus changes)
            minDate: me.periodDateRanges[periodType.COMPARE_PERIOD].minDate,
            maxDate: me.periodDateRanges[periodType.MAIN_PERIOD].maxDate,
            notateMissingData: true,
            i18n: {
                previousMonth: '<',
                nextMonth: '>',
                months: [
                    'January',
                    'February',
                    'March',
                    'April',
                    'May',
                    'June',
                    'July',
                    'August',
                    'September',
                    'October',
                    'November',
                    'December'
                ],
                weekdays: [
                    'Sunday',
                    'Monday',
                    'Tuesday',
                    'Wednesday',
                    'Thursday',
                    'Friday',
                    'Saturday'
                ],
                weekdaysShort: [
                    'Sun',
                    'Mon',
                    'Tue',
                    'Wed',
                    'Thu',
                    'Fri',
                    'Sat'
                ]
            }
        }, options);

        const pikaday = new window.Pikaday(me.options);

        me.render = function () {
            if (me.isDisabled) {
                pikaday.setDate(null, true);
            }
            pikaday.draw();
        };

        me.setField = function (periodType, index, el) {
            me.fieldPeriodType = periodType;
            me.fieldIndex = index;
            pikaday._o.maxDate = me.periodDateRanges[me.fieldPeriodType].maxDate;
            pikaday._o.minDate = me.periodDateRanges[me.fieldPeriodType].minDate;
            pikaday._d = moment($(el).val()).startOf('day').toDate();

            pikaday.draw();
        };

        me.gotoToday = function () {
            pikaday.gotoToday();
        };

        me.gotoMainEnd = function () {
            const me = this;

            const dates = me.periods[periodType.MAIN_PERIOD];
            const date = moment.utc(dates[1]).startOf('day').toDate();
            pikaday.gotoDate(date);
        };

        me.setDate = function (date) {
            pikaday.setDate(App.utils.convertToDay(date), true);
            pikaday.draw();
        };

        me.getDate = function () {
            return pikaday._d;
        };

        _.extend(me, Backbone.Events);

        me.options.container.appendChild(pikaday.el);
        me.gotoMainEnd();
    };

    DatePicker.prototype.isDateDisabled = function (date) {
        const me = this;

        return date < me.periodDateRanges[me.fieldPeriodType].minDate ||
            date > me.periodDateRanges[me.fieldPeriodType].maxDate;
    };

    DatePicker.prototype.disableDayFn = function (date) {
        const me = this;

        return me.isDisabled || me.isDateDisabled(date);
    };

    // BUG BUG mutates and is also probably deadly slow
    DatePicker.prototype.customDayClassFn = function (date) {
        const me = this;
        const arr = [];
        let dates = me.periods[periodType.COMPARE_PERIOD];

        // convert compare period to local dates since that's what pikaday uses
        const compareStart = moment(App.utils.convertToDay(dates[0])).startOf('day');
        const compareEnd = moment(App.utils.convertToDay(dates[1])).endOf('day');

        if (date >= compareStart && date <= compareEnd) {
            arr.push('compare-period');
        }

        dates = me.periods[periodType.MAIN_PERIOD];

        // convert main period to local dates since that's what pikaday uses
        const mainStart = moment(App.utils.convertToDay(dates[0])).startOf('day');
        const mainEnd = moment(App.utils.convertToDay(dates[1])).endOf('day');

        if (date >= mainStart && date <= mainEnd) {
            arr.push('main-period');
        } else if (moment.tz(me.timezone).diff(moment(date).tz(me.timezone, true), 'days', true) < 0) {
            arr.push('future-date');
        }

        if (me.isDateDisabled(date)) {
            arr.push('not-available');
        }

        if (me.options.notateMissingData && date < me.minDataDate) {
            arr.push('no-data');
        }

        if (arr.length) {
            return arr.join(' ');
        }
    };

    DatePicker.prototype.setPeriods = function (isDisabled, periods) {
        const me = this;

        me.isDisabled = isDisabled;
        me.periods = periods;
        me.render();
    };

    DatePicker.prototype.onSelect = function (date) {
        const me = this;

        // strip the time period from the pikaday date
        const locale = RivalIQ.utils.timePeriod.getLocale();
        const longDateFormat = _.get(moment.localeData(locale), ['_config', 'longDateFormat', 'L']);
        me.trigger('select', me.fieldPeriodType, me.fieldIndex, moment(date, longDateFormat).format(longDateFormat));
    };

}, window.moment);
